/*
  useThrottle.js
*/

// Npm.
import { useRef } from 'react';

/**
 * Throttles a function to stop it being spammed.
 */
export default function useThrottle(func, delay = 0) {

  const timerRef = useRef(null);

  return function withThrottle(...args) {
    if (timerRef.current == null) {

      timerRef.current = setTimeout(() => {
        timerRef.current = null;
      }, delay);

      func(...args);

    }
  };

}